import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { IoIosArrowDropright } from "react-icons/io";
import { IoIosArrowDropleft } from "react-icons/io";
import { useRef, useState } from "react";
import { FaPlay, FaPause } from "react-icons/fa";

const CertificateDocumentViewModalContent = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const files = data?.documents?.document_files || [];

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevIndex) => prevIndex - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < files?.length - 1) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }
  };

  if (!files?.length) return null;

  const currentFile = files[currentIndex];
  const lowerFile = currentFile?.toLowerCase();
  const isPdf = lowerFile?.endsWith(".pdf");
  const isVideo =
    lowerFile?.endsWith(".mp4") ||
    lowerFile?.endsWith(".webm") ||
    lowerFile?.endsWith(".mov") ||
    lowerFile?.endsWith(".ogg");

  const togglePlayPause = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="mt-5">
      <div className="w-full h-full relative flex justify-center items-center">
        {currentIndex > 0 && (
          <div
            className="absolute left-2 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer text-white text-3xl"
            onClick={handlePrev}
          >
            <IoIosArrowDropleft />
          </div>
        )}
        <div
          className="max-h-[450px] w-full overflow-y-auto flex justify-center items-start rounded-lg bg-black p-2"
          style={{ overflowX: "hidden", scrollbarWidth: "thin" }}
        >
          {isPdf ? (
            <iframe
              src={currentFile}
              title={`PDF Document ${currentIndex + 1}`}
              className="rounded-lg border-none w-[500px] h-[500px]"
            />
          ) : isVideo ? (
            <div
              className="relative w-full flex justify-center cursor-pointer"
              onClick={() => window.open(currentFile, "_blank")}
            >
              <video
                ref={videoRef}
                className="rounded-lg w-full max-h-[700px] object-contain pointer-events-none"
                onEnded={() => setIsPlaying(false)}
              >
                <source src={currentFile} type={`video/${lowerFile.split(".").pop()}`} />
                Your browser does not support the video tag.
              </video>
              {!isPlaying && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePlayPause();
                  }}
                  className="absolute inset-0 flex items-center justify-center text-white text-6xl bg-black/40 rounded-full w-20 h-20 m-auto"
                >
                  {isPlaying ? <FaPause /> : <FaPlay />}
                </button>
              )}
            </div>
          ) : (
            <a href={currentFile} target="_blank" rel="noopener noreferrer" className="inline-block">
              <img
                src={currentFile}
                alt={`Document ${currentIndex + 1}`}
                className="object-contain w-full max-h-[700px]"
              />
            </a>
          )}
        </div>
        {currentIndex < files?.length - 1 && (
          <div
            className="absolute right-2 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer text-white text-3xl"
            onClick={handleNext}
          >
            <IoIosArrowDropright />
          </div>
        )}
      </div>
    </div>
  );
};

const CertificateDocumentViewModal = () => {
  const modalState = useModalState("CERTIFICATE_DOCUMENT_VIEW_MODAL");
  const { setVisible } = useModalActions("CERTIFICATE_DOCUMENT_VIEW_MODAL");
  const handleClose = () => setVisible();

  return (
    <ModalPrompt
      modalId="CERTIFICATE_DOCUMENT_VIEW_MODAL"
      showIcon={false}
      titleIcon=""
      dialogClassName="sm:my-8 sm:w-full sm:max-w-2xl sm:p-6 h-[600px]"
      button={{
        primaryButtonText: "",
        secondaryButtonText: "",
        primaryButtonClassname: `px-6 py-[9px] rounded-md justify-center cursor-default`,
        primaryCallback: () => {},
        secondaryCallback: () => {
          handleClose();
        },
      }}
      title="Upload Document View"
      content={<CertificateDocumentViewModalContent data={modalState} />}
    />
  );
};

export default CertificateDocumentViewModal;
